<template>
    <div class="dacu-goods">
        <!-- 页面头部 -->
        <div class="header">
            <div class="header-left">
                <button class="back-btn" @click="goBack">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </button>
                <div class="title">获客指南</div>
            </div>
        </div>
        <!-- 加载状态 -->
        <div v-if="loading" class="loading">
            <div class="loading-spinner"></div>
            <p>正在加载指南内容...</p>
        </div>

        <!-- 枚举值列表 - 使用el-collapse展示 -->
        <div v-else class="results-section">
            <el-collapse>
                <el-collapse-item title="最新活动">
                    <div class="content-quill-editor">
                        <!-- 使用quill-editor组件（只读模式） -->
                        <quill-editor v-model="latestActivityText" :options="editorOption" readonly
                            disabled></quill-editor>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="关于团购">
                    <div class="content-quill-editor">
                        <div>
                            <p>1. 家电团购的优势在于价格优惠，因为我们有大量的私域垂直客户可以和商家直接谈优惠，我们把优惠机制做成攻略;</p>
                            <p>2. 客户通过我们攻略和转换过的链接跳转到京东下单，与自己在京东下单享受一样的权益，同时我们还能获得佣金;</p>
                            <p>3. 客户获得优惠、商家降低获客成本、我们获得佣金，从而实现三方共赢;</p>
                        </div>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="前期准备">
                    <div class="content-quill-editor">
                        <!-- 使用quill-editor组件（只读模式） -->
                        <quill-editor v-model="prepareText" :options="editorOption" readonly disabled></quill-editor>
                    </div>
                </el-collapse-item>
                <el-collapse-item title="上手操作">
                    <div class="content-quill-editor">
                        <!-- 使用quill-editor组件（只读模式） -->
                        <quill-editor v-model="startText" :options="editorOption" readonly disabled></quill-editor>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>

<script>
import { getEnumValues } from '@/utils/jdApi'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

export default {
    name: 'CustomerAcquisitionGuide',
    components: {
        quillEditor
    },
    data() {
        return {
            loading: false,
            startText: '',
            prepareText: '',
            latestActivityText: '',
            editorOption: {
                readOnly: true,
                modules: {
                    toolbar: false
                },
                theme: 'snow',
                placeholder: '暂无内容...'
            }
        }
    },
    mounted() {
        this.loadEnumValues()
    },
    methods: {
        // 加载枚举值数据
        async loadEnumValues() {
            this.loading = true
            try {
                const response = await getEnumValues({ page: 0, size: 10000, isActive: true })
                if (response.success) {
                    this.startText = response.data[0].startText || ''
                    this.prepareText = response.data[0].prepareText || ''
                    this.latestActivityText = response.data[0].latestActivityText || ''
                }
            } catch (error) {
                console.error('加载枚举值失败:', error)
                this.$message?.error?.('加载失败')
            } finally {
                this.loading = false
            }
        },

        goBack() {
            this.$router.go(-1)
        }
    }
}
</script>

<style scoped lang="scss">
.dacu-goods {
    margin: 0 auto;
    padding: 10px;
    background: #f8f9fa;
    height: 100vh;
    box-sizing: border-box;
}

.header {
    background: linear-gradient(135deg, #42b983, #369870);
    color: white;
    padding: 4px;
    margin-bottom: 10px;
    flex-shrink: 0;
    border-radius: 12px;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.back-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 4px;
    color: white;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.back-btn:hover {
    background: rgba(255, 255, 255, 0.2);
}

.back-btn svg {
    width: 20px;
    height: 20px;
}

.title {
    font-size: 18px;
    font-weight: 600;
    color: white;
}

.results-section {
    height: calc(100vh - 80px);
    overflow-y: auto;
}

.el-collapse {
    background: transparent;
    border: none;
}

.el-collapse-item {
    margin-bottom: 10px;
    border-radius: 12px !important;
    overflow: hidden;
    border: 1px solid #e1e8ed;
    padding: 0px 10px;
    background-color: #fff;
}



.guide-content {
    line-height: 1.6;
}

.content-quill-editor {
    width: 100%;
}

.content-quill-editor :deep(.ql-container) {
    border-radius: 4px;
    font-size: 14px;
    color: #495057;
}

.content-quill-editor :deep(.ql-editor) {
    padding: 12px;
    line-height: 1.7;
}

.content-quill-editor :deep(.ql-editor img) {
    max-width: 100% !important;
    height: auto !important;
    display: block;
    margin: 10px auto;
}

.content-quill-editor :deep(.ql-editor p) {
    margin: 10px 0;
}

.content-quill-editor :deep(.ql-editor a) {
    color: #42b983;
    text-decoration: underline;
}

.content-quill-editor :deep(.ql-editor *) {
    max-width: 100% !important;
    box-sizing: border-box;
}

.content-actions {
    display: flex;
    gap: 8px;
    margin-top: 20px;
}

.action-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 16px;
    border: none;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.copy-btn {
    background: #42b983;
    color: white;
}

.copy-btn:hover {
    background: #369870;
    transform: translateY(-1px);
}

.action-btn svg {
    width: 14px;
    height: 14px;
}

/* 空状态样式 */
.empty-state {
    text-align: center;
    padding: 60px 20px;
    color: #6c757d;
}

.empty-icon {
    font-size: 4rem;
    margin-bottom: 20px;
}

.empty-state h3 {
    margin: 0 0 10px 0;
    color: #495057;
    font-size: 18px;
}

.empty-state p {
    margin: 0;
    font-size: 14px;
}

/* 加载状态样式 */
.loading {
    text-align: center;
    padding: 40px 20px;
    color: #6c757d;
}

.loading-spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #42b983;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 16px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* 移动端适配 */
@media (max-width: 768px) {
    .page-header h2 {
        font-size: 20px;
    }

    .content-text {
        font-size: 14px;
    }

    .content-actions {
        flex-direction: column;
    }

    .action-btn {
        width: 100%;
        justify-content: center;
    }
}

::v-deep {
    .ql-container.ql-snow {
        border: none;
    }

    .ql-editor {
        padding: 0px !important;
    }

    .el-collapse-item__arrow {
        margin: 0 0 0 auto;
    }

    .el-collapse-item__content {
        border-top: #42b983 1px solid;
        background: white;
        padding: 10px;
        max-height: calc(100vh - 120px);
        overflow-y: auto;
    }

}
</style>